<div class="card flex-grow mb-0 product-creation-wizard" style="margin: 0 15px 15px; background-color: transparent">
  <div class="content-area-wrapper" style="height: 87vh; gap: 16px">
    <div class="card" style="width: 400px">
      <app-layout-steps-client
        [steps]="steps"
        [currentStep]="currentStep"
        (goBack)="retour()"
        (stepSelected)="onTimelineStepSelected($event)">
      </app-layout-steps-client>
    </div>

    <div class="card content-right custom-scroll" style="overflow: auto; flex: 1">
      <div class="content-wrapper p-0 content-right-r">
        <div class="card-body">
          <div class="wizard-content">
            <!-- Étape 1 : Établissement -->
            <div *ngIf="currentStep === 0" class="step-form">
              <h4 class="mb-2">{{ addMode ? 'Ajouter un magasin' : 'Établissement' }}</h4>
              <p class="text-muted mb-3">{{ stepHints[0] }}</p>
              <div class="form-section rounded p-3" [formGroup]="etablissementForm">
                <div class="form-group">
                  <label>Nom de l'établissement <span class="text-danger">*</span></label>
                  <input class="form-control" formControlName="libelle" placeholder="Ex. Agro Silo Tunis" />
                </div>
                <div class="form-group mb-0">
                  <label>Code établissement <span class="text-danger">*</span></label>
                  <input class="form-control" formControlName="code_etablissement" placeholder="Ex. 001" />
                  <small class="text-muted">Identifiant interne de votre magasin.</small>
                </div>
              </div>
            </div>

            <!-- Étape 2 : Entrepôt -->
            <div *ngIf="currentStep === 1" class="step-form">
              <h4 class="mb-2">Entrepôt</h4>
              <p class="text-muted mb-3">{{ stepHints[1] }}</p>
              <div class="alert alert-light border mb-3">
                <small>
                  Entrepôts liés à
                  <strong>{{ setupService.getWizardContext().etablissementLibelle }}</strong>
                </small>
              </div>

              <div *ngIf="entrepotStepLoading" class="text-muted mb-3">
                <span class="spinner-border spinner-border-sm mr-50"></span>
                Chargement des entrepôts…
              </div>

              <ng-container *ngIf="!entrepotStepLoading">
                <div class="form-section rounded p-3 mb-3" *ngIf="unlinkedEntrepotOptions.length">
                  <label class="font-weight-bold mb-1">Entrepôts existants</label>
                  <p class="text-muted small mb-2">
                    Un entrepôt ne peut être rattaché qu'à un seul établissement. Seuls les entrepôts
                    disponibles (non liés à un autre établissement) sont proposés.
                  </p>
                  <ng-select
                    [items]="unlinkedEntrepotOptions"
                    bindLabel="label"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Sélectionner un ou plusieurs entrepôts"
                    [(ngModel)]="selectedEntrepotIds"
                    [ngModelOptions]="{ standalone: true }"
                  ></ng-select>
                </div>

                <div class="form-section rounded p-3 mb-3" *ngIf="selectedEntrepotIds.length">
                  <label class="font-weight-bold mb-2 d-block">Sélection ({{ selectedEntrepotIds.length }})</label>
                  <div class="d-flex flex-wrap gap-2">
                    <span
                      *ngFor="let opt of linkedEntrepotOptionsForCaisse"
                      class="badge badge-light-primary d-inline-flex align-items-center px-1 py-50"
                    >
                      {{ opt.label }}
                      <button
                        type="button"
                        class="btn btn-sm btn-icon ml-50 p-0"
                        title="Retirer"
                        (click)="removeSelectedEntrepot(opt.id)"
                      >
                        <i data-feather="x" [size]="14"></i>
                      </button>
                    </span>
                  </div>
                </div>

                <div class="form-section rounded p-3" [formGroup]="entrepotForm">
                  <label class="font-weight-bold mb-1">Créer un entrepôt</label>
                  <p class="text-muted small mb-3">
                    Ajoutez un nouvel entrepôt à la sélection. Vous pouvez en créer plusieurs avant de continuer.
                  </p>
                  <div class="form-group">
                    <label>Nom de l'entrepôt <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="libelle" />
                  </div>
                  <div class="row mb-0">
                    <div class="col-md-4 form-group">
                      <label>Code entrepôt</label>
                      <input class="form-control" formControlName="code_entrepot" />
                    </div>
                    <div class="col-md-4 form-group">
                      <label>Ville</label>
                      <input class="form-control" formControlName="ville" />
                    </div>
                    <div class="col-md-4 form-group">
                      <label>Pays</label>
                      <input class="form-control" formControlName="pays" />
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-2">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      (click)="createAndAddEntrepot()"
                      [disabled]="addingEntrepot || entrepotForm.invalid"
                    >
                      <span *ngIf="addingEntrepot" class="spinner-border spinner-border-sm mr-50"></span>
                      Créer et ajouter
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- Étape 3 : Caisse -->
            <div *ngIf="currentStep === 2" class="step-form">
              <h4 class="mb-2">Caisse</h4>
              <p class="text-muted mb-3">{{ stepHints[2] }}</p>
              <div class="alert alert-light border mb-3">
                <small>
                  Entrepôts liés :
                  <strong>{{ selectedEntrepotsSummary }}</strong>
                </small>
              </div>

              <div class="form-section rounded p-3 mb-3" *ngIf="linkedEntrepotOptionsForCaisse.length > 1">
                <div class="form-group mb-0">
                  <label>Entrepôt pour la caisse <span class="text-danger">*</span></label>
                  <ng-select
                    [items]="linkedEntrepotOptionsForCaisse"
                    bindLabel="label"
                    bindValue="id"
                    placeholder="Choisir l'entrepôt"
                    [(ngModel)]="caisseEntrepotId"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onCaisseEntrepotChange()"
                  ></ng-select>
                  <small class="text-muted">La caisse sera créée sur l'entrepôt choisi.</small>
                </div>
              </div>

              <div class="form-section rounded p-3">
                <div class="alert alert-light border mb-2" *ngIf="linkedEntrepotOptionsForCaisse.length === 1">
                  <small>
                    Caisse pour l'entrepôt
                    <strong>{{ setupService.getWizardContext().entrepotLibelle }}</strong>
                  </small>
                </div>
                <div class="alert alert-primary mb-0">
                  <i data-feather="hash" [size]="18" class="mr-50"></i>
                  Numéro de caisse attribué automatiquement
                  <strong *ngIf="nextCaisseNumeroPreview != null"> — n° {{ nextCaisseNumeroPreview }}</strong>
                </div>
                <p class="text-muted small mt-2 mb-0">
                  Cliquez sur « Continuer » pour créer la caisse. Le serveur assigne le prochain numéro disponible pour cet entrepôt.
                </p>
              </div>
            </div>

            <!-- Étape 4 : Finalisation -->
            <div *ngIf="currentStep === 3" class="step-form">
              <h4 class="mb-2">Finalisation</h4>
              <p class="text-muted mb-3">{{ stepHints[3] }}</p>
              <div class="form-section rounded p-3 mb-3">
                <div class="alert alert-primary mb-0">
                  <i data-feather="check-circle" [size]="18" class="mr-50"></i>
                  Votre point de vente est opérationnel (établissement, entrepôt, caisse).
                </div>
              </div>

              <h5 class="mb-1">Vendeur (optionnel)</h5>
              <p class="text-muted small">
                Créez un vendeur et associez-le automatiquement à la caisse créée.
                Identifiant et mot de passe = codes numériques (PIN caisse, min. 6 chiffres).
              </p>

              <div [formGroup]="vendeurForm" class="row form-section rounded p-3">
                <div class="col-md-3 form-group">
                  <label>Identifiant</label>
                  <input
                    class="form-control"
                    formControlName="identifiant"
                    inputmode="numeric"
                    placeholder="Ex. 1001"
                  />
                </div>
                <div class="col-md-3 form-group">
                  <label>Prénom</label>
                  <input class="form-control" formControlName="prenom" />
                </div>
                <div class="col-md-3 form-group">
                  <label>Nom</label>
                  <input class="form-control" formControlName="nom" />
                </div>
                <div class="col-md-3 form-group">
                  <label>Code PIN (mot de passe)</label>
                  <input
                    type="password"
                    class="form-control"
                    formControlName="password"
                    inputmode="numeric"
                    placeholder="6 chiffres min."
                  />
                  <small class="text-muted">Uniquement des chiffres, au moins 6.</small>
                </div>
                <div class="col-md-4 form-group mb-0">
                  <label>Téléphone</label>
                  <input class="form-control" formControlName="telephone" />
                </div>
              </div>

              <hr />

              <h5 class="mb-1">Template ticket</h5>
              <p class="text-muted small mb-2">
                Les modèles par défaut sont déjà actifs. Vous pourrez les personnaliser plus tard.
              </p>
              <a routerLink="/main/parametre/ticket-templates" class="btn btn-sm btn-outline-primary">
                Personnaliser les templates
              </a>
            </div>

            <div class="d-flex justify-content-end mt-3 gap-2">
              <button
                *ngIf="currentStep === 3"
                type="button"
                class="btn btn-outline-secondary"
                (click)="skipFinalisation()"
                [disabled]="saving">
                Passer cette étape
              </button>
              <button type="button" class="btn btn-primary" (click)="next()" [disabled]="saving">
                <span *ngIf="saving" class="spinner-border spinner-border-sm mr-50"></span>
                {{ currentStep === 3 ? 'Terminer' : 'Continuer' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
